export default __webpack_public_path__ + "images/19d68005b04d3fdf58d034bd8db32947-psychedlic_small.webp";